import { createIsomorphicLogger } from '@/utils/logger/isomorphicLogger'

const logger = createIsomorphicLogger('utils.typeUtils')

export function getMediaTypeFromDataURL(dataURL: string): string | null {
  const matches = dataURL.match(/^data:([A-Za-z-+\/]+);base64/)
  return matches ? matches[1] : null
}

export function getBase64FromDataURL(dataURL: string): string | null {
  const matches = dataURL.match(/^data:[A-Za-z-+\/]+;base64,(.*)$/)
  return matches ? matches[1] : null
}

export async function blobToUint8Array(blob: Blob): Promise<Uint8Array> {
  const arrayBuffer = await blob.arrayBuffer()
  return new Uint8Array(arrayBuffer)
}

export function convertBase64ToBlob(base64DataUrl: string): Blob {
	const [prefix, base64] = base64DataUrl.split(',')
	const mimeType = prefix.match(/:(.*?);/)?.[1] || ''
	// Decode the base64 string
	const byteCharacters = atob(base64)
	const byteNumbers = new Array(byteCharacters.length)

	// Convert the decoded string into a byte array
	for (let i = 0; i < byteCharacters.length; i++) {
		byteNumbers[i] = byteCharacters.charCodeAt(i)
	}

	// Convert the byte array into a Blob
	const byteArray = new Uint8Array(byteNumbers)
	return new Blob([byteArray], { type: mimeType })
}

// Function to convert the object-based byte data to Uint8Array
export const convertToUint8Array = (data: Record<string, number>): Uint8Array => {
  const byteArray = new Uint8Array(Object.keys(data).length)
  Object.keys(data).forEach((key) => {
    byteArray[parseInt(key)] = data[key]
  })
  return byteArray
}

// Function to convert Uint8Array to Base64
export const uint8ArrayToBase64 = (byteArray: Uint8Array): string => {
  return Buffer.from(byteArray).toString('base64')
}

export const convertStringToBase64 = (str: string): string => {
	return Buffer.from(str, 'utf8').toString('base64')
}

export const convertBase64ToString = (base64: string): string => {
	return Buffer.from(base64, 'base64').toString('utf8')
}

// Utility function to chunk an array into smaller arrays of a given size
export function chunkArray<T>(array: T[], size: number): T[][] {
	const chunks: T[][] = [];
	for (let i = 0; i < array.length; i += size) {
			chunks.push(array.slice(i, i + size));
	}
	return chunks;
}

export function nullToUndef<T>(val: T | null): T | undefined {
  return val ?? undefined
}